import React, { useRef, useEffect } from 'react';

import classes from './Hero.module.scss';
import { getFileName } from 'helpers/FileCaching';

import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import { TweenMax, Power3, TimelineLite} from 'gsap';

//Images
const heroImages = require.context('../../../../assets/images/Article/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('../../../../assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);

const Hero = ({content, author, windowSize}) => {

    let heroContainer = useRef();
    let oval = useRef();
    let allScroll = useRef();
    let scrollMagicController = useRef();
    let scrollMagicScene = useRef();
    let oval_tl = useRef(new TimelineMax({paused:true}));
    let hero_tl = useRef(new TimelineLite({paused:true}));
   
    const configureScrollMagic = () => {
        //Configure scroll magic
        scrollMagicController.current = new ScrollMagic.Controller()
        scrollMagicScene.current = new ScrollMagic.Scene({
                                        triggerHook:0.7
                                    }).addTo(scrollMagicController.current)
        scrollMagicScene.current.triggerElement(heroContainer.current);
        scrollMagicScene.current.duration((600));
        scrollMagicScene.current.triggerHook('0');
        // scrollMagicScene.current.reverse(false);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })
    }

    const createTimeline = () => {
            TweenMax.set(oval.current,{opacity:0})
            hero_tl.current.to(allScroll.current, 1,{delay: -0.6, opacity:1, ease: Power3.easeOut});
            hero_tl.current.to(oval.current, 1,{delay: -0.6, opacity:1, ease: Power3.easeOut});
            hero_tl.current.play();

            oval_tl.current.fromTo(oval.current, .5,{ top:0},{ top:90});
        
    }

    const updateTimeline = (progress) => {
        let timelineLength = oval_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        oval_tl.current.tweenTo(tweenToSeconds);
    }


    useEffect(() => {
        createTimeline();
        configureScrollMagic();
      
    }, []);

	return(
		<div ref={heroContainer}  className={classes.Hero}>
            <div className={classes.Hero__bg}>

            </div>
            <div className={`${classes.Hero__image}`}
                style={
                    {
                        backgroundImage: 'url(' + getFileName(heroImages, content.backgroundImage[windowSize]) + ')'
                    }
                }>

                <div className={`scroll-container ${classes.Hero__scrollContainer}`}>
                    <div className="container">
                        <div ref={allScroll} className={`scroll-me ${classes.Hero__scrollMe}`}>
                            <div  className={`scroll-down-copy`}
                                style={
                                    {
                                        backgroundImage: 'url(' + getFileName(iconsImages, 'scroll_copy.svg') + ')'
                                    }
                                }>
                            </div>
                            <div className={`scroll-down-oval-container`}>
                                <div ref={oval} className={`scroll-down-oval`}
                                    style={
                                        {
                                            backgroundImage: 'url(' + getFileName(iconsImages, 'scroll_oval.svg') + ')'
                                        }
                                    }>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
           <div className={`container`}>
               <div className={`row`}>
                   <div className={`col-lg-8 ${classes.Hero__content}`}>
                        <h4 className={classes.Hero__subtitle}>{content.subTitle}</h4>
                        <h1 className={classes.Hero__title}>{content.title}</h1>
                        <p className={classes.Hero__author}>{content.writtenBy} {author.name}</p>
                        <p className={classes.Hero__description}>{content.description}</p>
                        {/* <p className={classes.Hero__description}>{content.introParagraph}</p> */}
                    </div>
                </div>
            </div>

		</div>
	)

}

export default Hero;